import React from 'react';
import { Button } from './Button';
import { useNavigate } from 'react-router-dom';

export const CallToAction: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className="py-24 bg-white border-t border-gray-100">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-4xl font-bold text-gray-900 tracking-tight mb-6">
          Start Analyzing Your Land in Minutes
        </h2>
        <p className="text-lg text-gray-600 mb-10">
          No complicated registration required. Try it now with any FP/TP number and see the insights instantly.
        </p>
        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <Button size="lg" className="shadow-lg shadow-green-600/20" onClick={() => navigate('/map')}>
            Start Analysis Now
          </Button>
          <Button size="lg" variant="outline">
            Contact Sales
          </Button>
        </div>
      </div>
    </section>
  );
};
